import React from 'react';
import { ConfigProvider } from 'antd';
import frFR from 'antd/locale/fr_FR';
import enGB from 'antd/locale/en_GB';
import { useTranslation } from 'react-i18next';

// Textes internes d'antd : calendriers, pagination, "Aucune donnee" des tables,
// boutons OK/Annuler des confirmations. En anglais britannique, comme dayjs.
const LOCALE_ANTD = { fr: frFR, en: enGB };

export const localeAntd = (langue) => LOCALE_ANTD[langue] || frFR;

/** ConfigProvider d'antd qui suit la langue choisie dans le selecteur. */
export default function LocalisationProvider({ theme, children }) {
  const { i18n } = useTranslation();
  return (
    <ConfigProvider locale={localeAntd(i18n.language)} theme={theme}>
      {children}
    </ConfigProvider>
  );
}
